export const INDEX = {
    role: 'ROLE_USER',
    route: '',
    name: 'index'
};

export const DASHBOARD = {
    role: 'ROLE_USER',
    route: '/dashboard',
    name: 'dashboard'
};


export const LOGIN = {
    route: '/login',
    name: 'login'
};

export const ORDERS = {
    role: 'ROLE_SALES',
    route: '/orders',
    name: 'orders'
};

export const PRODUCTS = {
    role: 'ROLE_STORE',
    route: '/products',
    name: 'products'
};

export const CLIENTS = {
    role: 'ROLE_SALES',
    route: '/clients',
    name: 'clients'
};

export const CLIENTS_LOAD_DISC = {
    role: 'ROLE_SALES',
    route: '/clients/load/disc',
    name: 'clients-load-stock'
};

export const PRODUCTS_LOAD = {
    role: 'ROLE_STORE',
    route: '/products/load',
    name: 'products-load'
};

export const PRODUCTS_LOAD_STOCK = {
    role: 'ROLE_STORE',
    route: '/products/load/stock',
    name: 'products-load-stock'
};

export const PRODUCT_EDITOR = {
    role: 'ROLE_STORE',
    route: '/product/:productId',
    name: 'product-editor'
};

export const PRODUCT_CREATOR = {
    role: 'ROLE_STORE',
    route: '/product',
    name: 'product-creator'
};


export const USER_EDITOR = {
    role: 'ROLE_ADMIN',
    route: '/user/:userId',
    name: 'user-editor'
};

export const USER_CREATOR = {
    role: 'ROLE_ADMIN',
    route: '/user',
    name: 'user-creator'
};

export const USERS = {
    role: 'ROLE_ADMIN',
    route: '/users',
    name: 'users'
};

export const FORBIDDEN = {
    route: '/404'
};




// WEBPACK FOOTER //
// ./src/router/routes.js